import classNames from 'classnames'
import React from 'react'

import { Loader } from '../loaderWrapper'

import styles from './pageLoader.module.scss'

interface PageLoaderProps {
  showLoader: boolean
  title?: string
  description?: string
  titleClassName?: string
  descriptionClassName?: string
}

function PageLoader({ showLoader, title, description, titleClassName, descriptionClassName }: PageLoaderProps) {
  return showLoader ? (
    <div className={styles.pageLoader} data-testid="page-loader">
      <div>
        {title ? <div className={classNames(styles.title, titleClassName)}>{title}</div> : null}
        {description ? <div className={classNames(styles.description, descriptionClassName)}>{description}</div> : null}
        <Loader showLoader />
      </div>
    </div>
  ) : null
}

export default PageLoader
